export var IngestionPartitionStatus;
(function (IngestionPartitionStatus) {
    IngestionPartitionStatus["INGESTION_PARTITION_STATUS_UNSPECIFIED"] = "INGESTION_PARTITION_STATUS_UNSPECIFIED";
    IngestionPartitionStatus["INGESTION_PARTITION_STATUS_CREATING"] = "CREATING";
    IngestionPartitionStatus["INGESTION_PARTITION_STATUS_CREATE_FAILED"] = "CREATE_FAILED";
    IngestionPartitionStatus["INGESTION_PARTITION_STATUS_ACTIVE"] = "ACTIVE";
    IngestionPartitionStatus["INGESTION_PARTITION_STATUS_DELETING"] = "DELETING";
})(IngestionPartitionStatus || (IngestionPartitionStatus = {}));
